
export default {
  name: "ProcessDelcop",
  components: {
  },
  setup() {
  }

};
